module.exports = __webpack_public_path__ + "static/benchmarking 2-736c837b54d9f9af6205633b2c925a0e.png";